import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 2C17.3284 2 18 2.67157 18 3.5V11.4609C18 11.4694 17.9982 11.4779 17.998 11.4863C17.9982 11.4909 18 11.4954 18 11.5C18 11.5119 17.9979 11.5235 17.9971 11.5352C17.9811 11.8564 17.8632 12.1633 17.6602 12.4111L17.5605 12.5215L12.5215 17.5605C12.2631 17.8189 11.92 17.9707 11.5576 17.9941C11.5386 17.9963 11.5196 18 11.5 18C11.4951 18 11.4902 17.9982 11.4854 17.998C11.4772 17.9982 11.4691 18 11.4609 18H3.5C2.67157 18 2 17.3284 2 16.5V3.5C2 2.67157 2.67157 2 3.5 2H16.5ZM3.5 3C3.22386 3 3 3.22386 3 3.5V16.5C3 16.7761 3.22386 17 3.5 17H11V13C11 11.8954 11.8954 11 13 11H17V3.5C17 3.22386 16.7761 3 16.5 3H3.5ZM13 12C12.4477 12 12 12.4477 12 13V16.668L16.668 12H13Z"
      fill="#B3BBCB"
    />
  </svg>
);
